export  const customDropdownBridgeStyles = {
  container: (provided) => ({
    ...provided,
    width: '100%',
  }),
  control: (provided, state) => ({
    ...provided,
    backgroundColor: 'white',
    height: '44px',
    borderRadius: '10px',
    border: `${state.focused ? '3' : '1'}px solid #44a5ff`,
    zIndex: 5,
    minWidth: '160px',
  }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
};